<template lang="pug">
    v-card.overflow-y-auto(
        v-bind:style="{ height: sheetHeight + 'px' }"
        color="white"
        elevation="4"
        shaped
    )
        v-toolbar(dense)
            v-icon.mr-2 mdi-calendar-today
            v-toolbar-title Account Today

        v-card-text
            .text-center(v-if="isLoading")
                v-progress-circular(
                    :size='100'
                    :width='10'
                    color='var(--volie-blue)'
                    indeterminate
                    style="margin-top: 100px; margin-bottom: 100px;"
                )

            template(v-else-if="validGoals && !isLoading")
                div(v-for="(goalArray, recurringType) in goals" :key="recurringType")
                    Radial(
                        :key="recurringType"
                        :goals="goalArray"
                    )

            v-alert(v-else outlined type='info' dense border='left' style="margin-top: 0px;")
                | No goal data found for today.
</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import Radial from '@/components/dashboards/live/tabs/goals/goal_radial.vue';

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {

        },
        computed: {
            validGoals() {
                return Object.keys(this.goals).length > 0;
            },
        },
        components: {
           Radial,
        },
        props: {
            goals: Object,
            isLoading: Boolean,
            sheetHeight: Number,
        },
        watch: {
            sheetHeight() {
                this.handleWindowResize();
            },
        },
        destroyed() {
        },
        created() {
        },
        mounted() {
        },
    });
</script>

<style lang="scss" scoped>
</style>
